module.exports = __webpack_public_path__ + "img/notfound.6695af99.svg";